module.exports = __webpack_public_path__ + "static/campsite-9760ec66329d0c4c522f093570c27ae3.png";